export const getFeatureCategoryTranslationKey = (category) => {
  return 'features' + category + 'CategoryTitle';
};
